import palette from 'src/designSystem/variables/palette'
import styled, { css } from 'styled-components/macro'

export const SimpleIconButton = styled.button<{
  $preserveIconStyles?: boolean
  $light?: boolean
}>`
  padding: 0;
  border: none;
  background-color: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ $preserveIconStyles, $light }) =>
    !$preserveIconStyles &&
    css`
      svg path {
        fill: ${$light ? palette.neutral[400] : palette.neutral[600]};
      }
    `}
  &:hover {
    svg path {
      fill: ${palette.neutral[300]};
      cursor: pointer;
    }
  }
  &:active {
    svg path {
      fill: ${palette.neutral[900]};
    }
  }
  &:disabled {
    svg path {
      fill: ${palette.neutral[300]};
      cursor: default;
    }
    &:hover {
      cursor: default;
    }
  }
  &:focus {
    outline: none;
  }
  &:focus-visible {
    outline: none;
  }
`
